import { z } from 'zod/v4';

/**
 * Server-side request validation for the /api/upscale route that proxies to the StockBlocks
 * Upscale AiTask endpoint (POST /ai-tasks/upscale). Limits mirror the StockBlocks
 * AiUpscalingController (app/AiTask/Controllers/AiUpscalingController.php).
 */
const MIN_DURATION = 2;
const MAX_DURATION = 30;

export const UPSCALE_TASK_TYPES = ['upscale_video_edit', 'upscale_video_generation'] as const;
export const UPSCALE_MODELS = ['topaz'] as const;

export const upscaleRequestSchema = z.object({
    // StockBlocks rejects a taskType that does not match the parent task's type, so the caller must
    // send the upscale type that corresponds to the tool the parent came from.
    taskType: z.enum(UPSCALE_TASK_TYPES),
    parentTaskId: z.number().int().positive(),
    duration: z.number().min(MIN_DURATION).max(MAX_DURATION),
    algoParams: z
        .object({
            modelId: z.enum(UPSCALE_MODELS),
        })
        .optional(),
});

export type UpscaleRequest = z.infer<typeof upscaleRequestSchema>;
